import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import * as thunk from 'redux-thunk';
import * as authenticationReducer from './store/authentication/reducers';
import * as companyReducer from './store/company/reducers';
import * as languageReducer from './store/language/reducers';

const thunkMiddleware = (thunk as any).default;

function logger() {
    return (next: any) => (action: any) => {
        // console.log('will dispatch', action);
        const returnValue = next(action);
        // console.log('state after dispatch', getState());
        return returnValue;
    };
}

export function configureStore(initialState: any): any {
    return composeWithDevTools(applyMiddleware(thunkMiddleware, logger))(createStore)(
        combineReducers({
            authentication: authenticationReducer.rootReducer,
            language: languageReducer.rootReducer,
            company: companyReducer.rootReducer,
        }),
        initialState,
    );
}
